module.exports = __webpack_public_path__ + "img/5.e7dd8ea8.png";